import {ReactNode} from 'react';
import {twMerge} from '../../../../common/twMerge';
import {BadgeList} from './BadgeList';
import {NewsTitle} from './NewsTitle';
import {Title} from './Title';

function ContentHomeSectionHeaderMain({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={twMerge(
        'w-full overflow-hidden rounded-t-12pxr px-18pxr',
        className
      )}
    >
      {children}
    </div>
  );
}

export const ContentHomeSectionHeader = Object.assign(
  ContentHomeSectionHeaderMain,
  {
    Title,
    BadgeList,
    NewsTitle,
  }
);
